import React from "react";
import { Link } from "react-router-dom";
import NavUp from "../commons/NavUp";
import Title from "./Login/Components/title/title";

class AppHome extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  render() {
    return (
      <React.Fragment>
        <NavUp />
        <Title text1="Welcome to Dent. Please, select an option." />
        <div className="text-center mt-5">
          <p>Are you...</p>
          <div className="mt-4">
            <Link to="/login">
              <button className="btn btn-secondary">Consumer</button>
            </Link>
          </div>
          <div className="mt-2">
            <Link to="/login_technician">
              <button className="btn btn-secondary">Technician</button>
            </Link>
          </div>
          <div className="mt-5 mb-5">
            <hr />
            <p className="d-inline text-muted">or</p> <hr />
          </div>
          <div className="mt-2">
            <Link to="/admin">
              <button className="btn btn-secondary">Administrator</button>
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default AppHome;
